import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

/* UTILS */
import { getRolesUtils, parsePhone } from '../../utils';

/* COMPONENT */
import { VerifyOtp } from "./OneTimePassword"
import ModalPassword from '../Modals/ModalPassword';
import { ModalAcceptOrder } from '../Modals';
import { ProgresVerify as ProgressVerify } from "./OneTimePassword/MainField"
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';

/* ACTIONS */
import {
  doHasPhoneRegis,
  doSubmitPhone,
  doVerifyOtp,
  doSentSMS,
  doSeller,
  doSellerToken,
  handleSuspended,
  doFetchUserBankAccount,
  doSentCitCall,
  checkOtpCode
} from '../../actions/saleActions';
import {
  postUserBankAccount,
  getBankList,
  saveRekening,
  dataBankList
} from '../../actions/postalCodeAction';
import {
  doSignOut,
  doRefreshToken,
  doFetchProfile
} from '../../actions/authAction';

/* LOCAL CONSTANTS */
const statusUser = ["unverified_user", "user", "seller"]

const SellerRegistration = ({
  doHasPhoneRegis,
  userPhoneSale,
  doSentSMS,
  checkOtpCode,
  updateBankAccount,
  userData,
  doSubmitPhone,
  postUserBankAccount,
  dataBankAccount,
  signOut,
  fetchBankList,
  doRefreshToken,
  doSentCitCall,
  countdown_modal,
  fetchProfile,
}) => {
  const [openModalPassword, setOpenModalPassword] = useState(false)
  const [numberPhone, setNumberPhone] = useState(0)
  const [ModalUnverified, setModalUnverified] = useState(false)
  const [_error, set_Error] = useState(null)
  const [_isSubmit, set_IsSubmit] = useState(false)
  const [password, setPassword] = useState("")
  const [dataBank, setDataBank] = useState({
    id: null
  })
  const [dataPhone, setDataPhone] = useState({});
  const [isOpen, setIsOpen] = useState(false)
  const [isVerifiedAlready, setIsVerifiedAlready] = useState(false);
  const history = useHistory();

  /* FUNCTIONS */
  const toggleModalPassword = (numberPhone, args_dataBank) => {
    setOpenModalPassword(!openModalPassword)
    setNumberPhone(numberPhone)
    setDataBank({
      ...dataBank,
      ...args_dataBank
    })
  }

  const toggleModalSellerVerification = async () => {
    await set_IsSubmit(false)
    await setOpenModalPassword(false)
    setIsOpen(!isOpen)
  }

  const _doHasPhoneRegis = () => {
    doHasPhoneRegis()
  }

  const _sentSms = () => {
    let { id } = userPhoneSale.dataPhoneUser.data
    doSentSMS({ id })
  }

  const _submitVerify = (code) => {
    doVerifyOtp({ ...userPhoneSale.dataPhoneUser.data, code })
  }

  const _handlePasswordText = (e) => {
    setPassword(e.target.value)
  }

  const _checkUser = async (e) => {
    e.preventDefault();

    try {
      await set_Error(null)
      await set_IsSubmit(!_isSubmit)

      await (async () => {
        if (password && password.length > 0) {
          let { roles } = userData
          roles = roles.join()
          if (roles === statusUser[0])
            return setModalUnverified(true)

          if (dataBank.id) {
            const { ...additionalPayloadPhone } = dataPhone;
            const payloadPhone = {
              mobile_number: `+62${numberPhone}`,
              address: dataPhone.address,
              ...additionalPayloadPhone,
            }

            if (payloadPhone.type === undefined) {
              return;
            }
            if (payloadPhone.full_name === undefined) {
              return;
            }
            if (payloadPhone.id_card === undefined) {
              return;
            }

            doSubmitPhone(payloadPhone).then(res => {
              setIsOpen(true)
              set_IsSubmit(!_isSubmit)
              fetchProfile();
            }).catch(err => {
              setIsOpen(false);
              set_Error(typeof err === 'string' ? err : err.message)
              set_IsSubmit(false)
              throw err;
            })
          } else {
            const payloadBank = {
              account_name: dataBank.account_name,
              account_number: dataBank.account_number,
              bank_name: dataBank.bank_name,
              password: password,
              seller_location_id: dataBank.province
            }
            const res = await postUserBankAccount(payloadBank)
            set_IsSubmit(!_isSubmit)
            if (isVerifiedAlready && res?.value?.status_code === 200) {
              toast.success('Submit success!', {
                position: 'top-right',
                autoClose: 3000,
                closeOnClick: true,
                pauseOnHover: true,
              });
              await fetchProfile();
              history.replace('/user_dashboard/sale');
            }
            setIsOpen(true)
          }
        }
      })();
    } catch (error) {
      let errorMessage = '';
      if (error?.response?.data?.error?.errors) {
        errorMessage = Object.keys(error.response.data.error.errors).map(t => error.response.data.error.errors[t][0])[0]
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message
      } else if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message
      } else if (error?.message) {
        errorMessage = error.message
      } else if (typeof error === 'string') {
        errorMessage = error
      } else {
        errorMessage = 'Sorry, we have a problem!. Please inform our friendly staff via Whatsapp: +6281210005425'
      }

      setIsOpen(false);
      set_Error(errorMessage)
      set_IsSubmit(false)
      toast.error('Submit failed, please try again later or contact our customer service.', {
        position: 'top-right',
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  }

  /* USE EFFECT */
  // 1. WITH DEPENDENDCIES
  useEffect(() => {
    try {
      if (updateBankAccount?.status_code === 200) {
        const { data } = dataBankAccount;
        if (data.length > 0) {
          setDataBank({
            id: data[0].id,
            account_name: data[0].account_name,
            account_number: data[0].account_number,
            bank_name: data[0].bank_name,
            seller_location_id: data[0].seller_location_id,
            isSubmit: false
          })
        }
        const { ...additionalPayloadPhone } = dataPhone;
        const payloadPhone = {
          mobile_number: `+62${numberPhone}`,
          address: dataPhone.address,
          ...additionalPayloadPhone
        }

        if (payloadPhone.type === undefined) {
          return;
        }
        if (payloadPhone.full_name === undefined) {
          return;
        }
        if (payloadPhone.id_card === undefined) {
          return;
        }

        doSubmitPhone(payloadPhone).then(res => {
          setOpenModalPassword(false)
          setPassword("")
          set_IsSubmit(false)
          fetchProfile();
        }).catch(err => {
          setIsOpen(false);
          set_Error(typeof err === 'string' ? err : err.message)
          set_IsSubmit(false)
          throw err;
        })
        // signOut()
      }
      else {
        if (updateBankAccount?.error) {
          const { error } = updateBankAccount;

          if (updateBankAccount.status_code === 422) {
            if (error.errors) {
              if (error.errors.password) {
                set_Error("Incorrect password")
                set_IsSubmit(false)
              }
            }
          }
        }
      }
    } catch (error) {
      let errorMessage = '';
      if (error?.response?.data?.error?.errors) {
        errorMessage = Object.keys(error.response.data.error.errors).map(t => error.response.data.error.errors[t][0])[0]
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message
      } else if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message
      } else if (error.message) {
        errorMessage = error.message
      } else if (typeof error === 'string') {
        errorMessage = error
      } else {
        errorMessage = 'Sorry, we have a problem!. Please inform our friendly staff via Whatsapp: +6281210005425'
      }

      setIsOpen(false);
      set_Error(errorMessage)
      set_IsSubmit(false)
      toast.error('Submit failed, please try again later or contact our customer service.', {
        position: 'top-right',
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  }, [updateBankAccount]);

  // 2. WITHOUT DEPENDENDCIES
  useEffect(() => {
    fetchBankList()
  }, []);

  useEffect(() => {
    if (!openModalPassword) {
      setPassword("");
      set_Error(null);
    }
  }, [openModalPassword]);

  /* COMPONENTS || MODAL */
  const _handleModalPassword = () => {
    return (
      <ModalPassword
        titleModal="Enter Password"
        isOpen={openModalPassword}
        onToggle={toggleModalPassword}
        value={password}
        onTextChange={_handlePasswordText}
        onClick={_checkUser}
        error={_error}
        isSubmit={_isSubmit}
        hasPassword={userData.have_password}
      />
    )
  }

  return <div id="seller-registration-page" className={countdown_modal ? 'is-countdown-active' : ''}>
    {_handleModalPassword()}
    <VerifyOtp
      onClick={{
        insertPassword: toggleModalPassword,
        setDataPhone: param => setDataPhone(param),
        checkPhone: _doHasPhoneRegis,
        sentSMS: _sentSms,
        submitVerify: _submitVerify,
      }}
      onData={{
        userPhone: userPhoneSale
      }}
      onUnverified={ModalUnverified}
      isSubmit={updateBankAccount.isFetch || userPhoneSale.dataPhoneUser.isFetch}
      userData={userData}
      doRefreshToken={doRefreshToken}
      doVerifyOtp={checkOtpCode}
      doSentCitCall={doSentCitCall}
      doSentSMS={doSentSMS}
      doSubmitPhone={doSubmitPhone}
      toggleModalSellerVerification={toggleModalSellerVerification}
      isOpen={isOpen}
      isVerifiedAlready={isVerifiedAlready}
      setIsVerifiedAlready={setIsVerifiedAlready}
    />
  </div>
}

const mapStateToProps = ({
  dataAuth: {
    userdata,
    refreshTkn,
    userSentLinkEmailVerify
  },
  dataCategory,
  dataOtp,
  dataHistory: {
    penjualan,
    pending,
    history,
    awb
  },
  dataSelling: {
    suspended
  },
  dataSortFilter: {
    doSellingSortFilter,
    doProcessSortFilter,
    doHistorySortFilter
  },
  dataPostalCode: {
    updatedUserBankAccount,
    userBankAccount
  },
  dataPostalCode,
  dataMenu,
}) => {
  return {
    userData: userdata,
    userPhoneSale: dataOtp,
    updateBankAccount: updatedUserBankAccount,
    dataBankAccount: userBankAccount,
    dataBankList: dataPostalCode.bankList,
    countdown_modal: dataMenu.countdown_modal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doHasPhoneRegis: () => dispatch(doHasPhoneRegis()),
    doSentSMS: (payload) => dispatch(doSentSMS(payload)),
    doVerifyOtp: (payload) => dispatch(doVerifyOtp(payload)),
    doSubmitPhone: (payload) => dispatch(doSubmitPhone(payload)),
    signOut: () => dispatch(doSignOut()),
    postUserBankAccount: (payload) => dispatch(postUserBankAccount(payload)),
    fetchBankList: () => dispatch(getBankList()),
    doRefreshToken: () => dispatch(doRefreshToken()),
    doSentCitCall: payload => dispatch(doSentCitCall(payload)),
    checkOtpCode: payload => dispatch(checkOtpCode(payload)),
    fetchProfile: () => dispatch(doFetchProfile()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SellerRegistration))